export const NANNY_FEATURE_CODE = 'nanny';
export const NANNY_SCOPE = 'nanny';
export const NANNY_ANALYSE_ERROR_CODE = 400;
export const NANNY_MAX_RULES = 10;
export const NANNY_CONTENT_JOIN_CHAR = ',';
export const NANNY_HANDLED_ERROR_CODES = ['ADMIN.NANNY.REGEXERROR', 'ADMIN.NANNY.FILEERROR'];
export const NANNY_REGEXP_SYNTAX_LINK = '`https://golang.org/s/re2syntax`';
